

const focusElementById = (elementId) => {
    const inputElement = document.getElementById(elementId);
    if (inputElement) { inputElement.focus() }
}

const onDropdownFilterValueKeydown = async (event, dropdownId, callback) => {

    const isExpended = event.currentTarget.ariaExpanded === 'true';

    if (event.key === 'Enter' && !isExpended) {

        focusElementById(dropdownId);
        callback();

    }
};

const onEnter = async (event, callback) => {

    if (event.key === 'Enter') { callback(event); }

};

export {
    focusElementById,
    onEnter,
    onDropdownFilterValueKeydown
}